import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const noOfSurveyImpressionGenratedAction = createAsyncThunk(
    'no-of-survey-impression-granted',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/no-of-survey-impression-granted?&s_date=${data?.s_date}&e_date=${data?.e_date}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const noOfSurveyImpressionGenratedSlice = createSlice({
    name: 'no-of-survey-impression-granted',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(noOfSurveyImpressionGenratedAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(noOfSurveyImpressionGenratedAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(noOfSurveyImpressionGenratedAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const noOfSurveyImpressionGenratedReducer = noOfSurveyImpressionGenratedSlice.reducer
